import { configure } from '@creditas/event-track';
import { productBu } from './constants';
import type { EventFormInteracted } from './types';
import type {
  FormFieldInteracted,
  FormButtonClicked,
  ContentDisplayInteracted,
} from '@creditas/event-track/dist/domain/events';
import type { ProductType } from '~/shared/domain/models';

export const configureEvents = (product: ProductType) => {
  const core = configure({
    application: 'acquisition-form-builder',
    bu: productBu[product],
    environment: process.env.APP_ENV === 'production' ? 'production' : 'staging',
  });

  const dispatchEventFormFieldInteracted = (props: EventFormInteracted<FormFieldInteracted>) => {
    return core.track('form_field_interacted', {
      journey: 'discovery',
      category: 'behavior',
      ...props,
    });
  };

  const dispatchEventButtonClicked = (
    element_name: string,
    props: EventFormInteracted<FormButtonClicked>,
  ) => {
    return core.track('form_button_clicked', {
      journey: 'discovery',
      category: 'behavior',
      element_name,
      ...props,
    });
  };

  const dispatchEventButtonIdentify = (payload: Record<string, unknown>) => {
    return core.identify(payload);
  };

  const dispatchEventContentDisplay = (props: EventFormInteracted<ContentDisplayInteracted>) => {
    return core.track('content_display_interacted', {
      journey: 'discovery',
      category: 'behavior',
      ...props,
    });
  };

  return {
    dispatchEventFormFieldInteracted,
    dispatchEventButtonClicked,
    dispatchEventButtonIdentify,
    dispatchEventContentDisplay,
  };
};
